import { render } from "./create.vue?vue&type=template&id=5a5f5e26&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import "@/css/view.css?vue&type=style&index=0&id=5a5f5e26&scoped=true&lang=css"
import "@/css/information.css?vue&type=style&index=1&id=5a5f5e26&scoped=true&lang=css"
import "./create.vue?vue&type=style&index=2&id=5a5f5e26&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mr.Wu\\Desktop\\Files\\XiHe\\code\\xihe_levelexam_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5f5e26"]])

export default __exports__